// src/config/AxiosInitializer.jsx
import { useEffect } from "react";
import axiosInstance from "./axiosInstance";
import { useLoading } from "../context/LoadingContext";

let interceptorsSet = false;

const AxiosInitializer = () => {
  const { setLoading } = useLoading();

  useEffect(() => {
    if (interceptorsSet) return;
    interceptorsSet = true;

    axiosInstance.interceptors.request.use(
      (config) => {
        setLoading(true);
        return config;
      },
      (error) => {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    axiosInstance.interceptors.response.use(
      (response) => {
        setLoading(false);
        return response;
      },
      (error) => {
        setLoading(false);
        return Promise.reject(error);
      }
    );
  }, [setLoading]);

  return null; // Este componente no renderiza nada
};

export default AxiosInitializer;